import { Message, RESTUtils } from '@galigeo-store/ui-lib';
import { PortalAppContext } from '../state/portal-appcontext';

export const getUserDetails = async () => {
  return getCurrentUser();
};

const getCurrentUser = async () => {
  const user = await RESTUtils.getJson(
    `${PortalAppContext.getBackendUrl()}/feature/portal/login`,
  );

  if (user.message) {
    Message.alert(user.message);
    return null;
  }

  const orgIdUrlParam = RESTUtils.getUrlParameter('orgId');
  if (orgIdUrlParam && user.orgId !== orgIdUrlParam) {
    user.orgId = orgIdUrlParam;
    RESTUtils.handleNotLoggedIn(user);
  }

  if (!user.profile && user.role) {
    // Case user from Galigeo.war
    user.profile = user.role;
  }
  return user;
};

export const isAdminUser = (): boolean => {
  const user = PortalAppContext.getCurrentUser();
  const capabilities = user ? user.capabilities : null;
  if (Array.isArray(capabilities)) {
    return capabilities.indexOf('admin') >= 0;
  } else if (typeof capabilities === 'string') {
    return capabilities.indexOf('admin') >= 0;
  }
  return false;
}